<main class="success">
  <div class="success__container">
    @if (loading()) {
      <p class="success__loading" role="status">Cargando tu pedido...</p>
    } @else if (notFound()) {
      <div class="success__not-found">
        <h1 class="success__title">Pedido no encontrado</h1>
        <p class="success__subtitle">
          El enlace puede haber expirado o no ser válido.
        </p>
        <app-button variant="primary" routerLink="/tienda">
          Volver a la tienda
        </app-button>
      </div>
    } @else if (preorder(); as p) {
      <header class="success__header">
        <img
          class="success__mascot"
          src="/images/logo/cart_success.png"
          alt=""
          loading="lazy"
        />
        <h1 class="success__title">¡Pedido recibido!</h1>
        <p class="success__subtitle">
          Gracias por tu compra. Te hemos enviado los detalles a
          <strong>{{ p.email }}</strong>.
        </p>
      </header>

      <section class="success__summary" aria-label="Resumen del pedido">
        <h2 class="success__summary-title">Resumen</h2>
        <dl class="success__details">
          <div class="success__detail-row">
            <dt>Número de pedido</dt>
            <dd>#{{ p.id }}</dd>
          </div>
          <div class="success__detail-row">
            <dt>Total</dt>
            <dd>{{ toAmount(p.total) | crc }}</dd>
          </div>
          <div class="success__detail-row">
            <dt>Método de envío</dt>
            <dd>
              @switch (p.delivery_method) {
                @case ('ps') { Retirar en Perrón Store }
                @case ('uber') { Mensajero por tu cuenta (Uber Flash, etc.) }
                @case ('other_shop') {
                  Envío a otra tienda
                  @if (p.shop_name) { ({{ p.shop_name }}) }
                }
                @case ('home') { Correos de Costa Rica }
                @case ('ps_delivery') { Mensajero de Perrón Store }
              }
            </dd>
          </div>
          @if (fullAddress(p); as address) {
            <div class="success__detail-row">
              <dt>Dirección</dt>
              <dd>{{ address }}</dd>
            </div>
          }
          @if (p.phone) {
            <div class="success__detail-row">
              <dt>Teléfono de contacto</dt>
              <dd>{{ p.phone }}</dd>
            </div>
          }
        </dl>
      </section>

      <section class="success__next" aria-label="Próximos pasos">
        <h2 class="success__next-title">¿Qué sigue?</h2>
        @if (isMonday()) {
          <p class="success__monday-notice" role="status">
            Los lunes la tienda permanece cerrada por descanso.
            @if (p.delivery_method === 'ps' && !preorderHasSingles(p)) {
              Podrás pasar a recoger tu pedido
              <strong>a partir del martes</strong>, cuando reabramos.
            } @else {
              Empezaremos a preparar tu pedido <strong>a partir del martes</strong>.
            }
          </p>
        }
        @if (p.delivery_method === 'ps' && preorderHasSingles(p)) {
          <p class="success__next-text">
            Las cartas individuales (singles) también se venden en nuestra tienda
            física. Si al preparar tu pedido no hubiera stock suficiente de alguna,
            te contactaremos para ofrecerte una solución o una alternativa.
          </p>
        } @else if (p.delivery_method === 'ps') {
          @if (!isMonday()) {
            <p class="success__next-text">
              Puedes pasar a recoger tu pedido en tienda,
              <strong>a partir de este momento.</strong>
            </p>
          }
        } @else {
          <p class="success__next-text">
            Revisaremos tu pedido y te contactaremos para confirmar disponibilidad
            y coordinar la entrega o pago.
          </p>
        }
        @if (p.delivery_method === 'ps') {
          <p class="success__next-text success__pickup-hours">
            {{ checkoutSuccessCopy.pickupHours }}
          </p>
        }
      </section>

      <div class="success__actions">
        <app-button variant="primary" routerLink="/tienda">
          Seguir comprando
        </app-button>
      </div>
    }
  </div>
</main>
